import React from "react";
import { Select, Icon, message } from "antd";
import classNames from "classnames";
import { inject, observer } from "mobx-react";

import Language from "../../language/language";
import agent from "../../../agent";
import UpdateSchoolInfo from "../../common/teamInfo/updateSchoolInfo";

import "../stylesheets/schoolItem.scss";

const Option = Select.Option;

@inject("languageStore")
@observer
class SchoolItem extends React.Component {
  searchTimeout = null;

  state = {
    schoolOptions: [],
    addModalVisible: false
  };

  handleOnSelect = value => {
    const result = value.split("||")[0];
    this.props.onChange && this.props.onChange(this.props.idx, result);
  };

  fetchOptions = name =>
    name
      ? agent.SassPlatform.searchSchools({ name, mode: "2" }).then(res => {
          if (res && res.success && Array.isArray(res.data) && res.data.length > 0) {
            this.setState({
              schoolOptions: res.data
            });
          } else {
            this.setState({
              schoolOptions: []
            });
          }
        })
      : this.setState({
          schoolOptions: []
        });

  handleOnSearch = name => {
    // 300ms防抖
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    this.searchTimeout = setTimeout(this.fetchOptions, 300, name);
  };

  renderOptions = () => {
    const lang = this.props.languageStore.lang;
    return this.state.schoolOptions.map(item => {
      const text = lang === "zh" ? item.name || item.enName : item.enName || item.name;
      return (
        <Option value={`${text}||${item.id}`} key={item.id}>
          {text}
        </Option>
      );
    });
  };

  showAddSchool = () => {
    this.setState({
      addModalVisible: true
    });
  };

  handleAddSchoolInfoCancel = () => {
    this.setState({
      addModalVisible: false
    });
  };

  handleAddSchoolInfoOk = data =>
    agent.SassPlatform.createSchool(data)
      .then(res => {
        if (res && res.success && res.data && res.data.id) {
          const name =
            this.props.languageStore.lang === "zh" && res.data.nameZh
              ? res.data.nameZh
              : res.data.nameEn;
          this.handleOnSelect(name);
          this.handleAddSchoolInfoCancel();
          return Promise.resolve();
        }
        if (res && res.success && res.data && !res.data.result && res.data.message) {
          message.error(
            this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "ADD_SCHOOL_INFO_ERROR_EXISTING"
            )
          );
        } else {
          message.error(
            this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "ADD_SCHOOL_INFO_ERROR"
            )
          );
        }
        return Promise.reject();
      })
      .catch(err => {
        if (err && err.response && err.response.body && err.response.body.code === "B3000004") {
          message.error(
            this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "ADD_SCHOOL_INFO_ERROR_EXISTING"
            )
          );
        } else
          message.error(
            this.props.languageStore.getResource(
              this.props.languageStore.lang,
              "ADD_SCHOOL_INFO_ERROR"
            )
          );
      });

  render() {
    const { value, className, canDelete, onRemove, disabled } = this.props;
    const { addModalVisible } = this.state;

    return (
      <div className={classNames("schoolItem", className)}>
        <Select
          className="schoolItem__select"
          value={value}
          showSearch
          placeholder={<Language resource="SCHOOL_TIP" />}
          optionFilterProp="children"
          onSelect={this.handleOnSelect}
          onSearch={this.handleOnSearch}
          onChange={this.handleOnSelect}
          allowClear={true}
          defaultActiveFirstOption={false}
          notFoundContent={null}
          filterOption={false}
          disabled={this.state.showNewSchoolItem || disabled}
        >
          {this.renderOptions()}
        </Select>
        {canDelete && !disabled ? (
          <Icon className="schoolItem__deleteIcon" type="minus-circle-o" onClick={onRemove} />
        ) : (
          <div className="schoolItem__deleteIcon--placeHolder" />
        )}
        {!disabled ? (
          <div className="schoolItem__newSchool" onClick={this.showAddSchool}>
            <Language resource="OTHER_SCHOOL" />
            <Icon type="plus-circle" />
          </div>
        ) : null}
        {addModalVisible && (
          <UpdateSchoolInfo
            title={<Language resource="ADD_SCHOOL_INFO" />}
            visible={addModalVisible}
            info={null}
            onCancel={this.handleAddSchoolInfoCancel}
            onOk={this.handleAddSchoolInfoOk}
          />
        )}
      </div>
    );
  }
}

export default SchoolItem;



// WEBPACK FOOTER //
// ./src/components/createTeam/schoolsForm/schoolItem.js